// src/Models/ticketSeverityModel.js
// -----------------------------------------------------------------------------
// Model class to transform properties between C# backend schema (camelCase/PascalCase)
// and the React frontend UI scheme (casing suffixes like ID).
// -----------------------------------------------------------------------------

export class TicketSeverityModel {
  static toFrontend(data) {
    if (!data) return null;
    return {
      severityID: data.severityId || data.severityID || 0,
      projectID: data.projectId || data.projectID || 0,
      severityName: data.severityName || '',
      sequenceOrder: data.sequenceOrder || 0,
    };
  }

  static toBackend(data) {
    if (!data) return null;
    return {
      severityId: Number(data.severityID || data.severityId || 0),
      projectId: Number(data.projectID || data.projectId || 0),
      severityName: data.severityName || '',
      sequenceOrder: Number(data.sequenceOrder || 0),
    };
  }
}
